module.exports = __webpack_public_path__ + "static/media/intro.2c24539d.jpeg";